export default __webpack_public_path__ + "media/zurb/img/events/wired/dst/dst-thumb-cf5e34eee43fb1e1ad9da661997b3953.png";